import { render, staticRenderFns } from "./land-contract.html?vue&type=template&id=3afac2b6&scoped=true&external"
import script from "./land-contract.js?vue&type=script&lang=js&external"
export * from "./land-contract.js?vue&type=script&lang=js&external"
import style0 from "./land-contract.scss?vue&type=style&index=0&id=3afac2b6&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3afac2b6",
  null
  
)

export default component.exports